module.exports = __webpack_public_path__ + "static/media/hyerim-jeong.11bc8027.png";